import {
  DATE_FORMATS,
  formatUtcDateTimeToTimeZone,
  PATHS,
} from '@belong/common';
import { Text, Button, Link } from '@belong/ui';
import {
  UnitListingDetailsModel,
  TourAttendeeDetailModel,
} from 'src/api/models';
import { ModalContactUsBottom } from 'src/components/modal-contact-us-bottom/modal-contact-us-bottom';
import { HOUSE_PAGE_STRINGS } from 'src/features/house-page/house-page.strings';
import { TourModalStep } from '../tour-modal';

type TourScheduledProps = {
  home: UnitListingDetailsModel;
  // Optional for the same reason as `TourCancel`: the step is rendered before
  // the booked-tours query resolves, and it returns `null` in that case.
  bookedTour?: TourAttendeeDetailModel;
  onDismiss: () => void;
  setStep: (step: TourModalStep) => void;
};

export function TourScheduled({
  bookedTour,
  home,
  onDismiss,
  setStep,
}: TourScheduledProps) {
  if (!bookedTour || !bookedTour.tour) {
    return null;
  }

  const { startOn, endOn, type: tourType, uniqueId: tourId } = bookedTour.tour;
  const { timeZone } = home.basicInfo!;
  const selfTourHref =
    tourType === 'SelfTour' && tourId
      ? `${PATHS.RESIDENT_SELF_TOUR_VISIT}/${tourId}`
      : undefined;
  const selfTourRescheduleHref = selfTourHref
    ? `${selfTourHref}?step=reschedule`
    : undefined;

  return (
    <>
      <div className="px-sm w-full">
        <div className="gap-xs flex flex-col items-center text-center ">
          <Text fontWeight="semibold" variant="h2">
            {HOUSE_PAGE_STRINGS['tour.youAreSet']}
          </Text>
          <Text className="text-dark-gray">
            {HOUSE_PAGE_STRINGS['tour.weLookForward']}
          </Text>
        </div>
        <div className="my-xl gap-sm flex flex-col items-center justify-between lg:flex-row">
          <div>
            {`${formatUtcDateTimeToTimeZone({ dateTime: startOn, format: DATE_FORMATS.LONG_DATE, timeZone })}
                 ${formatUtcDateTimeToTimeZone({ dateTime: startOn, format: DATE_FORMATS.TIME, timeZone })} -
                 ${formatUtcDateTimeToTimeZone({ dateTime: endOn, format: DATE_FORMATS.TIME_TIMEZONE, timeZone })}`}
          </div>
          <div className="gap-sm flex">
            {!!selfTourRescheduleHref && (
              <Link variant="text" href={selfTourRescheduleHref}>
                {HOUSE_PAGE_STRINGS['tour.reschedule']}
              </Link>
            )}
            {!selfTourHref && tourType !== 'PrivateTour' && (
              <Button
                variant="text"
                onClick={() => setStep(TourModalStep.TourSelection)}
              >
                {HOUSE_PAGE_STRINGS['tour.reschedule']}
              </Button>
            )}
            <Button
              variant="text"
              buttonType="danger"
              onClick={() => setStep(TourModalStep.TourCancel)}
            >
              {HOUSE_PAGE_STRINGS['tour.cancel']}
            </Button>
          </div>
        </div>
      </div>
      {!!selfTourHref && (
        <div className="px-sm mb-xl flex justify-center">
          <Link
            buttonType="primary"
            variant="solid"
            size={{ _: 'fluid', lg: 'large' }}
            href={selfTourHref}
          >
            {HOUSE_PAGE_STRINGS['tour.startSelfTour']}
          </Link>
        </div>
      )}
      <ModalContactUsBottom
        cta={HOUSE_PAGE_STRINGS['tour.done']}
        ctaSize={{ _: 'fluid', lg: 'large' }}
        onCtaClick={onDismiss}
      />
    </>
  );
}
